import templates from './activityMessageTemplates.json';

// Older system activities were stored as rendered text. Match only complete,
// known activity templates; ordinary messages never pass through this helper.
const patterns = templates
  .map(({ key, template }) => {
    const names = [];
    const parts = template.split(/(\{\w+\})/g);
    const pattern = parts
      .map(part => {
        if (/^\{\w+\}$/.test(part)) {
          const name = part.slice(1, -1);
          names.push(name);
          return name === 'count' ? '(\\d+)' : '(.+?)';
        }
        return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      })
      .join('');
    return {
      key,
      names,
      pattern: new RegExp(`^${pattern}$`, 's'),
      requiresResolvedStatus: template === '对话被 {contact_name} 重新打开',
      specificity: template.replace(/\{\w+\}/g, '').length,
    };
  })
  .sort((a, b) => b.specificity - a.specificity);

export const localizeActivityMessage = (content, locale, t, activity = {}) => {
  if (locale !== 'zh_CN' || !content) return content;

  const matched = patterns.find(({ key, pattern, requiresResolvedStatus }) => {
    // These two old Chinese templates were identical despite opposite meanings.
    if (requiresResolvedStatus && activity.status !== 'resolved') return false;
    if (key === 'status.open' && activity.status === 'resolved') return false;
    return pattern.test(content);
  });
  if (!matched) return content;

  const values = content.match(matched.pattern).slice(1);
  const params = Object.fromEntries(
    matched.names.map((name, index) => [name, values[index]])
  );

  if (params.user_name === 'Default Policy') {
    params.user_name = t('ACTIVITY_MESSAGES.default_policy');
  } else if (params.user_name === 'Automation System') {
    params.user_name = t('ACTIVITY_MESSAGES.automation');
  } else if (params.user_name?.startsWith('Automation System via ')) {
    params.user_name = t('ACTIVITY_MESSAGES.policy_actor', {
      policy_name: params.user_name.slice('Automation System via '.length),
    });
  }

  ['old_priority', 'new_priority'].forEach(name => {
    if (['urgent', 'high', 'medium', 'low', 'none'].includes(params[name])) {
      params[name] = t(`ACTIVITY_MESSAGES.priority_levels.${params[name]}`);
    }
  });

  return t(`ACTIVITY_MESSAGES.${matched.key}`, params);
};
